















































































import { Vue, Component } from 'vue-property-decorator';
import CortaCorriente from './CortaCorriente.vue';
import Tag from './Tag.vue';
import { LoadingService } from '@/services/loadingService';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';

@Component({
  components: { CortaCorriente, Tag },
})
export default class CortaCorrientePantalla extends Vue {
  readonly loadingService = new LoadingService();
  axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  readonly urlPg: string = 'Metabase/PostgenericA/track_corta_corriente/';
  //@ts-ignore
  readonly $snotify: any;
  showInfo: boolean = false;
  modelsList: any[] = [];
  tabmodel: string = 'cc_sitio';

  mounted() {
    this.getModels(this.tabmodel);
  }

  getModels(tab: any) {
    this.loadingService.showLoading();
    this.axios.http
      .post(`${this.urlPg}get_modelos_permitidos`, { tipocc: tab })
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.modelsList = response.data.data;
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error('Error al Obtener los Modelos');
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }
}
